import React, { useEffect, useState } from "react";
import "./CryptoCarousel.css";

interface MarketAsset {
  nombre: string;
  precio: number;
  tipo: "crypto" | "stock"; // Ahora recibimos el tipo desde el backend
}

const CryptoCarousel = () => {
  const [assets, setAssets] = useState<MarketAsset[]>([]);
  const [loading, setLoading] = useState(true);
  const [prevPrices, setPrevPrices] = useState<Record<string, number>>({});
  const [priceChanges, setPriceChanges] = useState<Record<string, "up" | "down" | null>>({});

  useEffect(() => {
    const fetchMarketData = async () => {
      try {
        // const res = await fetch("https://gestor-consumo-backend.fly.dev/api/crypto");
        const res = await fetch("https://gestor-consumo-backend.vercel.app/api/crypto");
        const data = await res.json();

        if (!data.error) {
          setPrevPrices((oldPrices) => {
            const changes: Record<string, "up" | "down" | null> = {};
            const newPrices: Record<string, number> = {};

            data.forEach((asset: MarketAsset) => {
              const previous = oldPrices[asset.nombre];
              if (previous !== undefined) {
                if (asset.precio > previous) changes[asset.nombre] = "up";
                else if (asset.precio < previous) changes[asset.nombre] = "down";
                else changes[asset.nombre] = null;
              }
              newPrices[asset.nombre] = asset.precio;
            });

            setPriceChanges(changes);
            setTimeout(() => setPriceChanges({}), 1500);
            return newPrices;
          });

          setAssets(data);
        }
      } catch (error) {
        console.error("Error cargando mercado:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchMarketData();
    const interval = setInterval(fetchMarketData, 30000); // 30s es más sano para las APIs
    return () => clearInterval(interval);
  }, []);

  // Función para obtener la URL del logo según el tipo
    const getLogoUrl = (asset: MarketAsset) => {
    if (asset.tipo === "crypto") {
        return `https://raw.githubusercontent.com/spothq/cryptocurrency-icons/master/128/color/${asset.nombre.toLowerCase()}.png`;
    } else {
        // Diccionario de dominios para CEDEARs/Acciones
        const domainMap: Record<string, string> = {
        AAPL: "apple.com",
        AMZN: "amazon.com",
        GOOGL: "google.com",
        MSFT: "microsoft.com",
        TSLA: "tesla.com",
        MELI: "mercadolibre.com",
        KO: "cocacola.com",
        NVDA: "nvidia.com"
        };

        const dominio = domainMap[asset.nombre] || "google.com";
        // Clearbit es excelente para logos de empresas
        return `https://financialmodelingprep.com/image-stock/${asset.nombre}.png`;
    }
    };

  if (loading) return <div className="text-center text-gray-400 py-2">Cargando mercado...</div>;
  if (assets.length === 0) return null;

  return (
    <div className="w-full bg-blue-950 backdrop-blur-sm border-b-2 border-green-500/80 overflow-hidden py-2 mb-6">
      <div className="flex animate-marquee whitespace-nowrap">
        {[...assets, ...assets].map((asset, i) => (
          <div key={i} className="inline-flex items-center mx-10 flex-shrink-0">
            <img
              src={getLogoUrl(asset)}
              alt={asset.nombre}
              className={`w-7 h-7 mr-2 rounded-full p-1 ${
                asset.tipo === "stock" ? "bg-white" : "bg-white/10"
              }`}
              onError={(e) => {
                e.currentTarget.src = "https://cdn-icons-png.flaticon.com/512/2533/2533515.png";
              }}
            />
            <span
              className={`font-mono font-bold transition-colors duration-300 ${
                priceChanges[asset.nombre] === "up"
                  ? "text-green-400"
                  : priceChanges[asset.nombre] === "down"
                  ? "text-red-400"
                  : "text-white"
              }`}
            >
              {asset.nombre} $
              {asset.precio.toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CryptoCarousel;